export default {
    /**
     * @description api请求基础路径
     */
    apiUrl: {
        dev: '/api',
        pro: 'http://wg.achina.xin/api', // 生产环境
        test: 'http://wg.achina.xin/api'
    },
    url: 'http://wg.achina.xin',
    // 请求白名单 无需token
    apiWhite: ['Login'],
    tokenName: '_TOKEN_KEY_COMPLETE_',
    setTenant: '__TENANT_ID__',
    setUser: '__USER__',
    setWorkShopName: '__WORKSHOP__',
    rememberInfo: '__REMEMBER_INFO__',
    isModal:'__IS_MODAL__'
}


// WEBPACK FOOTER //
// ./src/config/config.js